"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleSheet = void 0;
const react_native_1 = require("react-native");
const shared_1 = require("../../shared");
const documentStyle = globalThis.window?.getComputedStyle(globalThis.window?.document.documentElement);
const commonStyleSheet = {
    [shared_1.INTERNAL_FLAGS]: {},
    getFlag(name) {
        return documentStyle?.getPropertyValue(`--css-interop-${name}`);
    },
    [shared_1.INTERNAL_RESET](_options) {
        return;
    },
    unstable_hook_onClassName() { },
    register(_options) {
        throw new Error("Stylesheet.register is not available on web");
    },
    registerCompiled(_options) {
        throw new Error("Stylesheet.registerCompiled is not available on web");
    },
    getGlobalStyle() {
        throw new Error("Stylesheet.getGlobalStyle is not available on web");
    },
};
exports.StyleSheet = Object.assign({}, commonStyleSheet, react_native_1.StyleSheet);
//# sourceMappingURL=stylesheet.js.map